<template>
  <section class="contact" id="contact">
      <div class="contact__content container">
        <div class="contact__content--img">
          <img src="../assets/contact/sms.png">
        </div>
        <div class="contact__content--form">
          <div class="monday-form">
            <iframe src="https://forms.monday.com/forms/embed/3e1d69db8dba8ce683d7eafd831997fe?r=use1"
              frameborder="0"
              class="monday-iframe">
            </iframe>
          </div>
        </div>
      </div>
    </section>
  </template>

<style lang="scss" scoped>
@import "../styles/components/contact.scss";
</style>

<style lang="css">
::v-deep {
  .form-wrapper-component .form-content-component {
    background-color: var(--primary-background-color);
    color: var(--primary-text-color);
    box-shadow: 0px 0 4px 0px rgba(0,0,0,.1);
    width: 100%;
    max-width: 680px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    margin: auto auto 32px auto;
    transition: all .3s ease-in-out;
    box-sizing: border-box;
    transform: translateZ(0);
  }
}
</style>
